<template>
  <div class="flex flex--justify-center login">
    <div class="login__content">
      <div class="logo">
        <img src="../../assets/logo.png" alt="LiveRun">
      </div>
      <form class="login__form" @submit="handleSubmit($event)" novalidate>
        <div class="alert alert--danger" v-if="error" v-html="error"></div>
        <div class="alert alert--danger" v-if="!trainer"><strong>Failed to sign in!</strong> Only Trainer are allowed to access Live Run Console.</div>
        <div class="form__group">
          <label for="username">Username <span class="required">*</span></label>
          <input v-validate data-vv-rules="required" :class="{'form-control': true, 'is-danger': errors.has('username') }" type="text" name="username" v-model="user.username" required>
          <span v-show="errors.has('username')" class="help is-danger">Fill in the username</span>
        </div>
        <div class="form__group">
          <label for="password">Password <span class="required">*</span></label>
          <input v-validate data-vv-rules="required" :class="{'form-control': true, 'is-danger': errors.has('password') }" type="password" name="password" v-model="user.password" required>
          <span v-show="errors.has('password')" class="help is-danger">Fill in the password!</span>
        </div>
        <div class="form__group form__group--inline">
          <input type="checkbox" v-model="rememberMe" id="rememberMe" name="rememberMe">
          <label for="rememberMe">Remember me</label>
        </div>
         <div class="form__group form__group--inline">
         <router-link to="" slot="actions">Forget Password</router-link>
        </div>
        <button id="sign-in" class="btn btn--primary btn--block">Sign In</button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'login',
  data () {
    return {
      trainer:true,
      user: {
        username: null,
        password: null
      },
      rememberMe: false,
      error: ''
    }
  },
  computed: {
    ...mapGetters({
      istrainer: 'Trainer/istrainer'
    })
  },
  methods: {
    initialize () {
      this.trainer = this.istrainer
    },
    handleSubmit (e) {
      e.preventDefault()

      this.$validator.validateAll()
        .then(success => {
          if (!success) {
            return
          }

          this.loadingSignInButton()

          this.$auth.login({
            body: this.user,
            rememberMe: this.rememberMe,
            success: function(res) {
              this.error = ''
              this.resetSignInButton()
              this.setIsTrainer(true)
              
              // If rememberMe is checked, store the token in cookies for 1 year
              if (this.rememberMe) {
                // Calculate expiration date (1 year from now)
                const expirationDate = new Date();
                expirationDate.setFullYear(expirationDate.getFullYear() + 1);
                
                // Get the token from localStorage (where vue-auth stores it by default)
                const token = localStorage.getItem('default-auth-token');
                
                // Store token in cookies with 1 year expiration
                document.cookie = `auth_token=${token}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Strict`;
              }
            }.bind(this),
            error: function(res) {
              this.error = '<strong>Failed to sign in!</strong> Please check your credentials and try again.'
              this.resetSignInButton()
            }.bind(this)
          })
        })
    },
    loadingSignInButton () {
      const btnSignIn = document.querySelector('#sign-in')
      btnSignIn.innerHTML = 'Loading...'
      btnSignIn.setAttribute('disabled', true)
    },
    resetSignInButton () {
      const btnSignIn = document.querySelector('#sign-in')
      btnSignIn.innerHTML = 'Sign In'
      btnSignIn.removeAttribute('disabled', true)
    },
    ...mapActions({
      setIsTrainer: 'Trainer/setIsTrainer'
    })
  },
  created () {
    this.initialize()
  },
}
</script>



// WEBPACK FOOTER //
// Login.vue?0a4df286